import { callGet, callPost, callPut } from "./index";
import { DataDef } from "./data";
import { Estate } from "../models/Estate";
import { UserProfileJSON } from "../models/UserProfile";
import { Language, LanguageJson } from "../models/Langauges";
import { Subscription } from "../models/Subscription";
import { AssetCategory, AssetCategoryJSON } from "../models/AssetCategory";

export class AtticusMySQL {
  static async getLanguages(): Promise<Language[] | undefined> {
    try {
      const response = await callGet("/language", true);
      return response?.data?.map((json: LanguageJson) =>
        Language.fromJSON(json)
      );
    } catch (error) {
      console.error(error, "getLanguages error");
    }
  }

  static async getSubscription(userId: number): Promise<Subscription | undefined> {
    try {
      const response = await callGet(`/users/${userId}/subscription`, true);
      return Subscription.fromJSON(response?.data?.message);
    } catch (error) {
      console.error(error, "getSubscription error");
    }
  }

  static async updateUserProfile(
    userId: number,
    updateFields: UserProfileJSON
  ): Promise<boolean> {
    try {
      await callPut(`/users/${userId}/profile`, updateFields);
      return true;
    } catch (error) {
      console.error(error, "updateUserProfile error");
      throw error;
    }
  }

  static async getEstate(estateId: number): Promise<Estate | null> {
    try {
      const response = await callGet(`/estates/${estateId}`, true);
      if (response?.data) {
        return Estate.fromJSON(response.data);
      } else {
        console.error("no response.data", false);
      }
      // empty user indicates not authenticated or error
      return null;
    } catch (error) {
      console.error(error, "getEstate error");
      return null;
    }
  }

  static async getAssetCategories(userId: number): Promise<AssetCategory[]|undefined> {
    const response = await callGet(`users/${userId}/categories-subcategories`, false);
    return response?.data?.map((json: AssetCategoryJSON) =>
      AssetCategory.fromJSON(json)
    );
  }

  static async saveScreenData(
    screenData: DataDef,
    id?: number | string,
    dataToSave?: Record<string, string | number | boolean>
  ): Promise<boolean> {
    if (!dataToSave || !id) return false;
    try {
      const response = await callPost(`${screenData.api}/${id}`, dataToSave);
      console.log(`response.data: ${JSON.stringify(response?.data)}`);
      return true;
    } catch (error) {
      return false;
    }
  }
}
